import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ITitle } from 'src/app/title/title';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TitleService {

  private _url: string = environment.api_url;
  constructor(private _http: HttpClient) { }

  addTitle(title: ITitle):Observable<ITitle>{
    let httpheaders = new HttpHeaders().set('Content-Type','application/Json');
    let options = {
      headers: httpheaders
    };
    return this._http.post<ITitle>(this._url+'/addTitle.php',title, options);
  }

  getTitle(id:number){
    return this._http.get<ITitle[]>(this._url+'/eachTitle.php?id='+id);
  }

  updateTitle(title: ITitle){
    return this._http.put(this._url+'/updateTitle.php?id='+title.titleId, title);
  }

}
